export default __webpack_public_path__ + "43384a26036721153bac6f320f15df0f.svg";